import React from 'react'
import styled from 'styled-components'
import { Switch, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { FormCard, FormItem } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { Button, Text } from '@lmc/ui-kit/src/general'

type AdditionalDetailsSectionProps = {
  showAdditionalDetails: boolean
  onToggle: (checked: boolean) => void
  fileList: any[]
  onFileChange: (info: any) => void
  children?: React.ReactNode
}

const AdditionalDetailsSection: React.FC<AdditionalDetailsSectionProps> = ({
  showAdditionalDetails,
  onToggle,
  fileList,
  onFileChange,
  children
}) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  return (
    <>
      <FormCard level={2}>
        <SwitchContainer>
          <Switch
            checked={showAdditionalDetails}
            onChange={onToggle}
            data-testid="additional-details-switch"
          />
          <SwitchLabel>{t('ADDITIONAL_DETAILS')}</SwitchLabel>
        </SwitchContainer>
      </FormCard>

      {showAdditionalDetails && (
        <>
          <FormCard level={2}>
            <FormItem name="media" label={<Text>{t('MEDIA')}</Text>} full>
              <MediaContainer>
                <Upload
                  fileList={fileList}
                  listType="picture"
                  onChange={onFileChange}
                  beforeUpload={() => false}
                  multiple
                >
                  <Button>
                    <UploadOutlined />
                    {t('CLICK_TO_UPLOAD')}
                  </Button>
                </Upload>
              </MediaContainer>
            </FormItem>
          </FormCard>
          {children}
        </>
      )}
    </>
  )
}

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const SwitchLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const MediaContainer = styled.div`
  width: 100%;
`

export default AdditionalDetailsSection
